import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IGallery, IHomeInitialState } from "./homeModel";
import {
  getAllActiveBanner,
  getAllActiveGallerys,
  getAllActiveSettings,
  getAllCMSByURL,
  getAllMetaData,
  getHomeDetails,
  insertInquiry,
} from "./services/home.services";

const initialState: IHomeInitialState = {
  loading: false,
  galleryloading: false,
  formLoading: false,
  error: "",
  homeDetails: {},
  CMSList: [],
  BannerList: [],
  SettingList: [],
  MetaDetails: {
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
  },
  GalleryList: [],
  cmsUrl: "",
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setHomeDetails: (state, action) => {
      state.homeDetails = action.payload;
      state.loading = false;
    },
    setCMSList: (state, action: PayloadAction<any[]>) => {
      state.CMSList = action.payload || [];
      state.loading = false;
    },
    setMetaDetails: (state, action: PayloadAction<any>) => {
      state.MetaDetails = action.payload || initialState.MetaDetails;
      state.loading = false;
    },
    setSettingList: (state, action: PayloadAction<any[]>) => {
      state.SettingList = action.payload || [];
      state.loading = false;
    },
    setBannerList: (state, action: PayloadAction<any[]>) => {
      state.BannerList = action.payload || [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomeDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHomeDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.homeDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getHomeDetails.rejected, (state, action) => {
      state.loading = false;
      state.homeDetails = initialState.homeDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllCMSByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCMSByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.CMSList = action.payload || [];
      state.cmsUrl = action.meta.arg;
      state.error = "";
    });
    builder.addCase(getAllCMSByURL.rejected, (state, action) => {
      state.loading = false;
      state.CMSList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllMetaData.pending, (state) => {
      state.loading = true;
      state.MetaDetails = initialState.MetaDetails;
    });
    builder.addCase(getAllMetaData.fulfilled, (state, action) => {
      state.loading = false;
      state.MetaDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getAllMetaData.rejected, (state, action) => {
      state.loading = false;
      state.MetaDetails = initialState.MetaDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveSettings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveSettings.fulfilled, (state, action) => {
      state.loading = false;
      state.SettingList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllActiveSettings.rejected, (state, action) => {
      state.loading = false;
      state.SettingList = initialState.SettingList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveBanner.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveBanner.fulfilled, (state, action) => {
      state.loading = false;
      state.BannerList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveBanner.rejected, (state, action) => {
      state.loading = false;
      state.BannerList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertInquiry.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertInquiry.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertInquiry.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveGallerys.pending, (state) => {
      state.galleryloading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveGallerys.fulfilled,
      (state, action: PayloadAction<IGallery[]>) => {
        state.galleryloading = false;
        state.GalleryList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveGallerys.rejected, (state, action) => {
      state.galleryloading = false;
      state.error = action.error.message || "Something went wrong";
      state.GalleryList = [];
    });

    // builder.addCase(getAllBranches.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getAllBranches.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.BranchesList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getAllBranches.rejected, (state, action) => {
    //   state.loading = false;
    //   state.BranchesList = initialState.BranchesList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getAllActiveWorkPlace.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getAllActiveWorkPlace.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.WorkPlaceList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getAllActiveWorkPlace.rejected, (state, action) => {
    //   state.loading = false;
    //   state.WorkPlaceList = initialState.WorkPlaceList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getPortfolioItems.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getPortfolioItems.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.PortfolioList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getPortfolioItems.rejected, (state, action) => {
    //   state.loading = false;
    //   state.PortfolioList = initialState.PortfolioList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getJobOpenings.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getJobOpenings.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.OpeningList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getJobOpenings.rejected, (state, action) => {
    //   state.loading = false;
    //   state.OpeningList = initialState.OpeningList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getBestPlace.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getBestPlace.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.BestPlaceList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getBestPlace.rejected, (state, action) => {
    //   state.loading = false;
    //   state.BestPlaceList = initialState.BestPlaceList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getGallaryImage.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getGallaryImage.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.GalleryImageList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getGallaryImage.rejected, (state, action) => {
    //   state.loading = false;
    //   state.GalleryImageList = initialState.GalleryImageList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getWorkCulture.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getWorkCulture.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.WorkCultureList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getWorkCulture.rejected, (state, action) => {
    //   state.loading = false;
    //   state.WorkCultureList = initialState.WorkCultureList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getTeamMembers.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getTeamMembers.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.TeamMemberList = action.payload;
    //   state.error = "";
    // });
    // builder.addCase(getTeamMembers.rejected, (state, action) => {
    //   state.loading = false;
    //   state.TeamMemberList = initialState.TeamMemberList;
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getAllActiveTestimonials.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getAllActiveTestimonials.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.TestominalList = action.payload || [];
    //   state.error = "";
    // });
    // builder.addCase(getAllActiveTestimonials.rejected, (state, action) => {
    //   state.loading = false;
    //   state.TestominalList = [];
    //   state.error = action.error.message || "Something went wrong";
    // });

    // builder.addCase(getAllActiveClients.pending, () => {
    //   // state.loading = true;
    // });
    // builder.addCase(getAllActiveClients.fulfilled, (state, action) => {
    //   // state.loading = false;
    //   state.ClientList = action.payload || [];
    //   state.error = "";
    // });
    // builder.addCase(getAllActiveClients.rejected, (state, action) => {
    //   // state.loading = false;
    //   state.ClientList = [];
    //   state.error = action.error.message || "Something went wrong";
    // });
  },
});

export default homeSlice.reducer;
export const {
  setHomeDetails,
  setCMSList,
  setMetaDetails,
  setSettingList,
  setBannerList,
} = homeSlice.actions;
